/**
 * 带默认404页的switch
 */

import { Switch, SwitchProps, Route } from '@medlinker/fundamental';
import React, { PropsWithChildren, useEffect } from 'react';
import useTitle from '../../hooks/usePageConfig/useTitle';
import MedLink from '../MedLink';

import styles from './index.module.scss';

function NotFound() {
  useTitle('页面未找到');

  useEffect(() => {
    if (typeof Sentry !== 'undefined') {
      Sentry.withScope((scope: any) => {
        scope.setExtra('url', window.location.href);
        Sentry.captureException(new Error('页面未找到'));
      });
    }
  }, []);

  return (
    <div className={styles.container}>
      <img src={require('./404.png')} />
      <div className={styles.h1}>哎呀，您访问的页面没找到</div>
      <MedLink className={styles.h2} to="/home" replace>
        随便看看
      </MedLink>
    </div>
  );
}

export default (props: PropsWithChildren<SwitchProps>) => {
  return (
    <Switch>
      {props.children}
      <Route path="*" component={NotFound} />
    </Switch>
  );
};
